/**
 * Created by lg on 18/5/22.
 */
const ConfigHelper = {};

/*系统配置*/
export function init(target) {
    //实名认证url, 激活url ,请求url, 带宽计费url，订单跳转url, 工单url, 物理机帮助文档url,
    // 防火墙操作指南url,规格类型url,购买须知url,支付服务条款url,续费url,激活url
    var realName_url, complete_url, login_url, server_url, band_Width_BillUrl, order_url, work_url, cps_help_url,
    fire_help_url, type_help_url, buy_help_url, pay_server_url, renew_console_url, return_url,
    //ddos链接，子网帮助文档，eip帮助文档，vpc帮助文档, eip购买须知, eip服务条款, ipv6帮助文档, 监控插件url, 负载均衡帮助文档, nat网关帮助文档，共享带宽帮助文档，对等连接帮助文档, 镜像帮助文档
    ddos_url, subnet_url, eip_url, vpc_url, eip_buy_url, eip_term_url, ipv6_url, agent_url, slb_help_url, nat_help_url,sbw_help_url,peering_help_url, mirror_help_url,
    // 负载均衡购买须知，获取真实IP操作指南，路由表帮助文档, SSH帮助文档, 设置报警规则,sos操作指南,95增强带宽文档
    slb_buy_help_url, real_ip_url, routeTable_help_url, ssh_help_url,monitor_rule_url,sos_url,enhanced_bandwidth_url,game_help_url,steam_url,game_faq_url,game_deployment_url,work_order_url,EDCPS_GAME_REGION_WHITELIST;
    switch (process.env.BUILD_ENV) {
        case 'local': //host配置pre环境
            realName_url = 'https://realname.jdcloud.com/account/verify';
            complete_url = 'https://uc.jdcloud.com/passport/account-activation-login';
            work_url = 'https://uc.jdcloud.com/myorder/form?cateId=394&questionId=1324';
            //带宽计费（创建页面）
            band_Width_BillUrl = 'https://docs.jdcloud.com/cloud-physical-server/price-overview';
            //云物理主机帮助文档（产品控制台页面右上角）
            cps_help_url = 'https://docs.jdcloud.com/cloud-physical-server/product-overview';
            //防火墙操作指南（创建页，详情页-资源信息）
            fire_help_url = 'https://docs.jdcloud.com/cloud-physical-server/steps-network-and-security';
            //规格类型详情（创建页）
            type_help_url = 'https://docs.jdcloud.com/cloud-physical-server/specifications';
            //购买须知（创建页）
            buy_help_url = 'https://docs.jdcloud.com/cloud-physical-server/billing-overview';
            //云物理服务器服务条款（订单确认页、续费页）
            pay_server_url = 'https://docs.jdcloud.com/product-service-agreement/cloud-physics-server-service-clause';
            /*本地环境---使用代理 config下proxyConfig.js*/
            server_url = '/apis';
            /*本地环境---192.168.238.207*/
            order_url = 'http://buy.jdcloud.com';
            renew_console_url = 'http://renewal-console.jdcloud.com';
            return_url = 'http://local.console.jdcloud.com:8080';
            login_url = "http://uc.jdcloud.com/login";
            //ddos操作指南文档链接
            ddos_url = "https://docs.jdcloud.com/anti-ddos-basic/anti-ddos-basic-started"
            //子网帮助文档
            subnet_url = "https://docs.jdcloud.com/cloud-physical-server/subnet"
            //弹性IP帮助文档
            eip_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //私有网络帮助文档
            vpc_url = "https://docs.jdcloud.com/cloud-physical-server/virtual-network-interface"
            //eip购买须知
            eip_buy_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //eip服务条款
            eip_term_url = "https://docs.jdcloud.com/product-service-agreement/elastic-ip-for-physical-cloud-terms-of-service"
            //监控插件url
            agent_url = 'https://docs.jdcloud.com/cloud-physical-server/monitoring-overview'
            // ipv6帮助文档
            ipv6_url = "https://docs.jdcloud.com/cloud-physical-server/ipv6-internet-access"
            //slb帮助文档
            slb_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //nat帮助文档
            nat_help_url = "https://docs.jdcloud.com/cloud-physical-server/NAT-Gateway"
            //共享带宽帮助文档
            sbw_help_url = "https://docs.jdcloud.com/cloud-physical-server/shared-bandwidth"
            //slb购买须知
            slb_buy_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //获取真实IP操作指南
            real_ip_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //路由表帮助文档
            routeTable_help_url = "https://docs.jdcloud.com/cloud-physical-server/route-table"
            // SSH帮助文档
            ssh_help_url = "https://docs.jdcloud.com/cloud-physical-server/description-ssh-key-pair"
            //设置报警规则
            monitor_rule_url = "http://cms-console-stag.jdcloud.com/"
            //sos操作指南
            sos_url = "https://docs.jdcloud.com/cloud-physical-server/sos"
            // 对等连接帮助文档
            peering_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 镜像帮助文档
            mirror_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 95增强带宽文档
            enhanced_bandwidth_url = "https://docs.jdcloud.com/cn/cloud-physical-server/shared-bandwidth";
            //游戏服务器帮助文档
            game_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //Steam
            steam_url = "https://store.steampowered.com/";
            //游戏服务器常见问题
            game_faq_url = "https://docs.jdcloud.com/cn/cloud-physical-server/faq-game-instance";
            //快速部署
            game_deployment_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //游戏实例vpc工单url
            work_order_url = "https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001";
            // edcps边缘游戏服务器地域白名单
            EDCPS_GAME_REGION_WHITELIST = ['cn-north-sjz1']; // cn-north-sjz1=华北-石家庄
        break;
        case 'dev': //续费 跳转等 未打通 一般不使用
            realName_url = 'https://realname.jdcloud.com/account/verify';
            complete_url = 'https://uc.jdcloud.com/passport/account-activation-login';
            work_url = 'https://uc.jdcloud.com/myorder/form?cateId=394&questionId=1324';
            //带宽计费（创建页面）
            band_Width_BillUrl = 'https://docs.jdcloud.com/cloud-physical-server/price-overview';
            //云物理主机帮助文档（产品控制台页面右上角）
            cps_help_url = 'https://docs.jdcloud.com/cloud-physical-server/product-overview';
            //防火墙操作指南（创建页，详情页-资源信息）
            fire_help_url = 'https://docs.jdcloud.com/cloud-physical-server/steps-network-and-security';
            //规格类型详情（创建页）
            type_help_url = 'https://docs.jdcloud.com/cloud-physical-server/specifications';
            //购买须知（创建页）
            buy_help_url = 'https://docs.jdcloud.com/cloud-physical-server/billing-overview';
            //云物理服务器服务条款（订单确认页、续费页）
            pay_server_url = 'https://docs.jdcloud.com/product-service-agreement/cloud-physics-server-service-clause';
            /*开发环境 172.18.168.156*/
            server_url = '/cps_api';
            /*开发环境---192.168.238.207*/
            order_url = 'http://buy.jdcloud.com';
            renew_console_url = 'http://renewal-console.jdcloud.com';
            return_url = 'http://dev.cps-console.jdcloud.com';
            login_url = "http://uc.jdcloud.com/login";
            //ddos操作指南文档链接
            ddos_url = "https://docs.jdcloud.com/anti-ddos-basic/anti-ddos-basic-started"
            //子网帮助文档
            subnet_url = "https://docs.jdcloud.com/cloud-physical-server/subnet"
            //弹性IP帮助文档
            eip_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //私有网络帮助文档
            vpc_url = "https://docs.jdcloud.com/cloud-physical-server/virtual-network-interface"
            //eip购买须知
            eip_buy_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //eip服务条款
            eip_term_url = "https://docs.jdcloud.com/product-service-agreement/elastic-ip-for-physical-cloud-terms-of-service"
            // ipv6帮助文档
            ipv6_url = "https://docs.jdcloud.com/cloud-physical-server/ipv6-internet-access"
            //监控插件url
            agent_url = 'https://docs.jdcloud.com/cloud-physical-server/monitoring-overview'
            //slb帮助文档
            slb_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //nat帮助文档
            nat_help_url = "https://docs.jdcloud.com/cloud-physical-server/NAT-Gateway"
            //共享带宽帮助文档
            sbw_help_url = "https://docs.jdcloud.com/cloud-physical-server/shared-bandwidth"
            //slb购买须知
            slb_buy_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //获取真实IP操作指南
            real_ip_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //路由表帮助文档
            routeTable_help_url = "https://docs.jdcloud.com/cloud-physical-server/route-table"
            // SSH帮助文档
            ssh_help_url = "https://docs.jdcloud.com/cloud-physical-server/description-ssh-key-pair"
            //设置报警规则
            monitor_rule_url = "http://cms-console-stag.jdcloud.com/"
            //sos操作指南
            sos_url = "https://docs.jdcloud.com/cloud-physical-server/sos"
            // 对等连接帮助文档
            peering_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 镜像帮助文档
            mirror_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 95增强带宽文档
            enhanced_bandwidth_url = "https://docs.jdcloud.com/cn/cloud-physical-server/shared-bandwidth";
            //游戏服务器帮助文档
            game_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //Steam
            steam_url = "https://store.steampowered.com/";
            //游戏服务器常见问题
            game_faq_url = "https://docs.jdcloud.com/cn/cloud-physical-server/faq-game-instance";
            //快速部署
            game_deployment_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //游戏实例vpc工单url
            work_order_url = "https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001";
            // edcps边缘游戏服务器地域白名单
            EDCPS_GAME_REGION_WHITELIST = ['cn-north-sjz1']; // cn-north-sjz1=华北-石家庄
        break;
        case 'test': //续费 跳转等 未打通 一般不使用
            realName_url = 'https://realname.jdcloud.com/account/verify';
            complete_url = 'https://uc.jdcloud.com/passport/account-activation-login';
            work_url = 'https://uc.jdcloud.com/myorder/form?cateId=394&questionId=1324';
            //带宽计费（创建页面）
            band_Width_BillUrl = 'https://docs.jdcloud.com/cloud-physical-server/price-overview';
            //云物理主机帮助文档（产品控制台页面右上角）
            cps_help_url = 'https://docs.jdcloud.com/cloud-physical-server/product-overview';
            //防火墙操作指南（创建页，详情页-资源信息）
            fire_help_url = 'https://docs.jdcloud.com/cloud-physical-server/steps-network-and-security';
            //规格类型详情（创建页）
            type_help_url = 'https://docs.jdcloud.com/cloud-physical-server/specifications';
            //购买须知（创建页）
            buy_help_url = 'https://docs.jdcloud.com/cloud-physical-server/billing-overview';
            //云物理服务器服务条款（订单确认页、续费页）
            pay_server_url = 'https://docs.jdcloud.com/product-service-agreement/cloud-physics-server-service-clause';
            /*测试环境 192.168.167.50 */
            server_url = '/cps_api';
            /*测试环境---192.168.238.207*/
            order_url = 'http://buy.jdcloud.com';
            renew_console_url = 'http://renewal-console.jdcloud.com';
            return_url = 'http://cps-console.jdcloud.com';
            login_url = "http://uc.jdcloud.com/login";
            //ddos操作指南文档链接
            ddos_url = "https://docs.jdcloud.com/anti-ddos-basic/anti-ddos-basic-started"
            //子网帮助文档
            subnet_url = "https://docs.jdcloud.com/cloud-physical-server/subnet"
            //弹性IP帮助文档
            eip_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //私有网络帮助文档
            vpc_url = "https://docs.jdcloud.com/cloud-physical-server/virtual-network-interface"
            //eip购买须知
            eip_buy_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //eip服务条款
            eip_term_url = "https://docs.jdcloud.com/product-service-agreement/elastic-ip-for-physical-cloud-terms-of-service"
            // ipv6帮助文档
            ipv6_url = "https://docs.jdcloud.com/cloud-physical-server/ipv6-internet-access"
            //监控插件url
            agent_url = 'https://docs.jdcloud.com/cloud-physical-server/monitoring-overview'
            //slb帮助文档
            slb_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //nat帮助文档
            nat_help_url = "https://docs.jdcloud.com/cloud-physical-server/NAT-Gateway"
            //共享带宽帮助文档
            sbw_help_url = "https://docs.jdcloud.com/cloud-physical-server/shared-bandwidth"
            //slb购买须知
            slb_buy_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //获取真实IP操作指南
            real_ip_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //路由表帮助文档
            routeTable_help_url = "https://docs.jdcloud.com/cloud-physical-server/route-table"
            // SSH帮助文档
            ssh_help_url = "https://docs.jdcloud.com/cloud-physical-server/description-ssh-key-pair"
            //设置报警规则
            monitor_rule_url = "http://cms-console-stag.jdcloud.com/"
            //sos操作指南
            sos_url = "https://docs.jdcloud.com/cloud-physical-server/sos"
            // 对等连接帮助文档
            peering_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering"
            // 镜像帮助文档
            mirror_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 95增强带宽文档
            enhanced_bandwidth_url = "https://docs.jdcloud.com/cn/cloud-physical-server/shared-bandwidth";
            //游戏服务器帮助文档
            game_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //Steam
            steam_url = "https://store.steampowered.com/";
            //游戏服务器常见问题
            game_faq_url = "https://docs.jdcloud.com/cn/cloud-physical-server/faq-game-instance";
            //快速部署
            game_deployment_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //游戏实例vpc工单url
            work_order_url = "https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001";
            // edcps边缘游戏服务器地域白名单
            EDCPS_GAME_REGION_WHITELIST = ['cn-north-sjz1']; // cn-north-sjz1=华北-石家庄
        case 'pre':
            realName_url = 'https://realname.jdcloud.com/account/verify';
            complete_url = 'https://uc.jdcloud.com/passport/account-activation-login';
            work_url = 'https://uc.jdcloud.com/myorder/form?cateId=394&questionId=1324';
            //带宽计费（创建页面）
            band_Width_BillUrl = 'https://docs.jdcloud.com/cloud-physical-server/price-overview';
            //云物理主机帮助文档（产品控制台页面右上角）
            cps_help_url = 'https://docs.jdcloud.com/cloud-physical-server/product-overview';
            //防火墙操作指南（创建页，详情页-资源信息）
            fire_help_url = 'https://docs.jdcloud.com/cloud-physical-server/steps-network-and-security';
            //规格类型详情（创建页）
            type_help_url = 'https://docs.jdcloud.com/cloud-physical-server/specifications';
            //购买须知（创建页）
            buy_help_url = 'https://docs.jdcloud.com/cloud-physical-server/billing-overview';
            //云物理服务器服务条款（订单确认页、续费页）
            pay_server_url = 'https://docs.jdcloud.com/product-service-agreement/cloud-physics-server-service-clause';
            /*预发环境 192.168.162.38 */
            server_url = '/cps_api';
            /*预发环境---192.168.238.207*/
            order_url = 'http://buy.jdcloud.com';
            /*预发环境---192.168.246.2*/
            renew_console_url = 'http://renewal-console.jdcloud.com';
            return_url = 'http://cps-console.jdcloud.com';
            login_url = "http://uc.jdcloud.com/login";
            //ddos操作指南文档链接
            ddos_url = "https://docs.jdcloud.com/anti-ddos-basic/anti-ddos-basic-started"
            //子网帮助文档
            subnet_url = "https://docs.jdcloud.com/cloud-physical-server/subnet"
            //弹性IP帮助文档
            eip_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //私有网络帮助文档
            vpc_url = "https://docs.jdcloud.com/cloud-physical-server/virtual-network-interface"
            //eip购买须知
            eip_buy_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //eip服务条款
            eip_term_url = "https://docs.jdcloud.com/product-service-agreement/elastic-ip-for-physical-cloud-terms-of-service"
            // ipv6帮助文档
            ipv6_url = "https://docs.jdcloud.com/cloud-physical-server/ipv6-internet-access"
            //监控插件url
            agent_url = 'https://docs.jdcloud.com/cloud-physical-server/monitoring-overview'
            //slb帮助文档
            slb_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //nat帮助文档
            nat_help_url = "https://docs.jdcloud.com/cloud-physical-server/NAT-Gateway"
            //共享带宽帮助文档
            sbw_help_url = "https://docs.jdcloud.com/cloud-physical-server/shared-bandwidth"
            //slb购买须知
            slb_buy_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //获取真实IP操作指南
            real_ip_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //路由表帮助文档
            routeTable_help_url = "https://docs.jdcloud.com/cloud-physical-server/route-table"
            // SSH帮助文档
            ssh_help_url = "https://docs.jdcloud.com/cloud-physical-server/description-ssh-key-pair"
            //设置报警规则
            monitor_rule_url = "http://cms-console-stag.jdcloud.com/"
            //sos操作指南
            sos_url = "https://docs.jdcloud.com/cloud-physical-server/sos"
            // 对等连接帮助文档
            peering_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 镜像帮助文档
            mirror_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 95增强带宽文档
            enhanced_bandwidth_url = "https://docs.jdcloud.com/cn/cloud-physical-server/shared-bandwidth";
            //游戏服务器帮助文档
            game_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //Steam
            steam_url = "https://store.steampowered.com/";
            //游戏服务器常见问题
            game_faq_url = "https://docs.jdcloud.com/cn/cloud-physical-server/faq-game-instance";
            //快速部署
            game_deployment_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //游戏实例vpc工单url
            work_order_url = "https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001";
            // edcps边缘游戏服务器地域白名单
            EDCPS_GAME_REGION_WHITELIST = ['cn-north-sjz1']; // cn-north-sjz1=华北-石家庄
        break;
        case 'prod':
        default:
            realName_url = 'https://realname.jdcloud.com/account/verify';
            complete_url = 'https://uc.jdcloud.com/passport/account-activation-login';
            work_url = 'https://uc.jdcloud.com/myorder/form?cateId=394&questionId=1324';
            //带宽计费（创建页面）
            band_Width_BillUrl = 'https://docs.jdcloud.com/cloud-physical-server/price-overview';
            //云物理主机帮助文档（产品控制台页面右上角）
            cps_help_url = 'https://docs.jdcloud.com/cloud-physical-server/product-overview';
            //防火墙操作指南（创建页，详情页-资源信息）
            fire_help_url = 'https://docs.jdcloud.com/cloud-physical-server/steps-network-and-security';
            //规格类型详情（创建页）
            type_help_url = 'https://docs.jdcloud.com/cloud-physical-server/specifications';
            //购买须知（创建页）
            buy_help_url = 'https://docs.jdcloud.com/cloud-physical-server/billing-overview';
            //云物理服务器服务条款（订单确认页、续费页）
            pay_server_url = 'https://docs.jdcloud.com/product-service-agreement/cloud-physics-server-service-clause';
            /*线上环境*/
            server_url = '/cps_api';
            /*线上环境*/
            order_url = 'http://buy.jdcloud.com';
            /*线上环境*/
            renew_console_url = 'http://renewal-console.jdcloud.com';
            return_url = 'https://cps-console.jdcloud.com';
            login_url = "https://uc.jdcloud.com/login";
            //ddos操作指南文档链接
            ddos_url = "https://docs.jdcloud.com/anti-ddos-basic/anti-ddos-basic-started"
            //子网帮助文档
            subnet_url = "https://docs.jdcloud.com/cloud-physical-server/subnet"
            //弹性IP帮助文档
            eip_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //私有网络帮助文档
            vpc_url = "https://docs.jdcloud.com/cloud-physical-server/virtual-network-interface"
            //eip购买须知
            eip_buy_url = "https://docs.jdcloud.com/cloud-physical-server/elastic-ip-for-physical-cloud"
            //eip服务条款
            eip_term_url = "https://docs.jdcloud.com/product-service-agreement/elastic-ip-for-physical-cloud-terms-of-service"
            // ipv6帮助文档
            ipv6_url = "https://docs.jdcloud.com/cloud-physical-server/ipv6-internet-access"
            //监控插件url
            agent_url = 'https://docs.jdcloud.com/cloud-physical-server/monitoring-overview'
            //slb帮助文档
            slb_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //nat帮助文档
            nat_help_url = "https://docs.jdcloud.com/cloud-physical-server/NAT-Gateway"
            //共享带宽帮助文档
            sbw_help_url = "https://docs.jdcloud.com/cloud-physical-server/shared-bandwidth"
            //slb购买须知
            slb_buy_help_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //获取真实IP操作指南
            real_ip_url = "https://docs.jdcloud.com/cloud-physical-server/load-balancer"
            //路由表帮助文档
            routeTable_help_url = "https://docs.jdcloud.com/cloud-physical-server/route-table"
            // SSH帮助文档
            ssh_help_url = "https://docs.jdcloud.com/cloud-physical-server/description-ssh-key-pair"
            //设置报警规则
            monitor_rule_url = "https://cms-console.jdcloud.com/"
            //sos操作指南
            sos_url = "https://docs.jdcloud.com/cloud-physical-server/sos"
            // 对等连接帮助文档
            peering_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering"
            // 镜像帮助文档
            mirror_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/vpc-peering";
            // 95增强带宽文档
            enhanced_bandwidth_url = "https://docs.jdcloud.com/cn/cloud-physical-server/shared-bandwidth";
            //游戏服务器帮助文档
            game_help_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //Steam
            steam_url = "https://store.steampowered.com/";
            //游戏服务器常见问题
            game_faq_url = "https://docs.jdcloud.com/cn/cloud-physical-server/faq-game-instance";
            //快速部署
            game_deployment_url = "https://docs.jdcloud.com/cn/cloud-physical-server/black-wukong";
            //游戏实例vpc工单url
            work_order_url = "https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001";
            // edcps边缘游戏服务器地域白名单
            EDCPS_GAME_REGION_WHITELIST = ['cn-central-xy1']; // cn-central-xy1=华中-襄阳
        break;
    }
    if (!realName_url || !complete_url || !login_url || !server_url || !order_url || !work_url || !band_Width_BillUrl
        || !cps_help_url || !fire_help_url || !type_help_url || !buy_help_url || !pay_server_url
        || !ddos_url || !eip_url || !vpc_url || !eip_url || !eip_term_url || !ipv6_url ||!agent_url || !slb_help_url || !slb_buy_help_url || !nat_help_url || !sbw_help_url || !peering_help_url
        || !real_ip_url|| !routeTable_help_url || !ssh_help_url ||!monitor_rule_url||!sos_url || !mirror_help_url || !enhanced_bandwidth_url || !game_help_url || !steam_url || !game_faq_url || !game_deployment_url || !work_order_url || !EDCPS_GAME_REGION_WHITELIST) {
        console.log('  Build ConfigHelper config url have null, build env :' + process.env.BUILD_ENV)
    }

    //存储cookie前缀
    var cookie = "CPS_WEB";
    return {
        //根vue
        'ROOT_VUE': target,
        //请求url
        'SERVER_URL': server_url,
        //订单url
        'ORDER_URL': order_url,
        //工单url
        'WORK_URL': work_url,
        // 带宽计费url(创建页面)
        'Band_Width_BillUrl': band_Width_BillUrl,
        //物理机帮助文档url
        'CPS_HELP_URL': cps_help_url,
        //防火墙操作指南url
        'FIRE_HELP_URL': fire_help_url,
        //规格类型url
        'TYPE_HELP_URL': type_help_url,
        //购买须知url
        'BUY_HELP_URL': buy_help_url,
        //服务条款url
        'PAY_SERVER_URL': pay_server_url,
        //请求成功状态
        'AJAX_STATUS_SUCCESS': 10000,
        //订单错误
        'ORDER_ERROR': 20450,
        //cookie的工程前缀，避免不同项目的cookie重复
        'COOKIE_PREFIX': cookie,
        //用户信息 暂时不用
        'COOKIE_USER_INFO': cookie + 'COOKIE_USER_INFO',
        //重定向url
        'RETURN_URL': return_url,
        //续费页url
        'RENEW_CONSOLE_URL': renew_console_url,
        //登录页url
        'LOGIN_URL': login_url,
        //激活页url
        'COMPLETION_URL': complete_url,
        //DDOS URL
        'DDOS_URL': ddos_url,
        //子网帮助文档
        'SUBNET_URL': subnet_url,
        //弹性IP帮助文档
        'EIP_URL': eip_url,
        //ipv6帮助文档
        'IPV6_URL': ipv6_url,
        //私有网络帮助文档
        'VPC_URL': vpc_url,
        //eip购买须知
        'EIP_BUY_URL': eip_url,
        //eip服务条款
        'EIP_TERM_URL': eip_term_url,
        //监控插件url
        'AGENT_URL': agent_url,
        //slb帮助文档
        'SLB_HELP_URL': slb_help_url,
        //nat帮助文档
        'NAT_HELP_URL': nat_help_url,
        //共享带宽帮助文档
        'SBW_HELP_URL' : sbw_help_url,
        // slb购买须知
        'SLB_BUY_HELP_URL': slb_buy_help_url,
        // 获取真实IP操作指南
        'REAP_IP_URL': real_ip_url,
        // 路由表帮助文档
        'ROUTETABLE_HELP_URL' : routeTable_help_url,
        // 实名认证帮助文档
        'REALNAME_URL': realName_url,
        // SSH帮助文档
        'SSH_HELP_URL': ssh_help_url,
        //设置报警规则
        'MONITOR_RULE_URL': monitor_rule_url,
        //sos操作指南
        'SOS_URL':sos_url ,
        //对等连接帮助文档
        'PEERING_HELP_URL': peering_help_url,
        // 镜像帮助文档
        'MIRROR_HELP_URL': mirror_help_url,
        // 95增强带宽文档
        'ENHANCED_BANDWIDTH_URL': enhanced_bandwidth_url,
        //游戏服务器帮助文档
        'GAME_HELP_URL': game_help_url,
        //Steam
        'STEAM_URL': steam_url,
        //游戏服务器常见问题
        'GAME_FAQ_URL': game_faq_url,
        //快速部署
        'GAME_DEPLOYMENT_URL': game_deployment_url,
        //游戏实例vpc工单url
        'WORK_ORDER_URL': work_order_url,
        // edcps边缘游戏服务器地域白名单
        // @TODO 注意⚠️： 该白名单是根据edcps游戏实例地域白名单配置的，如果edcps游戏实例地域白名单有变动，请同步修改该白名单，现状：边缘edcps只开通了预发：cn-north-sjz1=华北-石家庄， 线上：cn-central-xy1=华中-襄阳
        'EDCPS_GAME_REGION_WHITELIST': EDCPS_GAME_REGION_WHITELIST,
    };
}

export default ConfigHelper;



// WEBPACK FOOTER //
// ./src/common/ConfigHelper.js